<template lang="pug">
  div
    el-row
      el-col(:xs='20', :sm='16', :md='14', :lg='10', :xl='8')
        el-card.box-card(shadow='hover')
          .clearfix(slot='header')
            h3(align='center') Testing eDoatap
          .text.item
            el-form.ruleForm(:model='testingParams', status-icon='', label-width='80px')
              el-form-item(label='Όνομα')
                el-input(type='name', v-model='testingParams.email', auto-complete='off')
              el-form-item(label='Κωδικώς')
                el-input(type='password', v-model='testingParams.password', auto-complete='off')
              el-form-item(label='Αίτηση')
                el-input(type='textarea', v-model='testingParams.application.toString()', auto-complete='off')
              div
                el-button(type='primary', @click='login()', id='loginSubmit') Υποβολή
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'E2eTest',
  data () {
    return {
      hasScope: false,
      testingParams: {
        email: 'doatap1',
        password: 'doatap11111',
        application: {}
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          return false
        }
      })
    },
    login () {
      this.$store.dispatch('login', { name: this.testingParams.email, password: this.testingParams.password })
      var now = new Date().getTime()
      var wait = 3000
      while (new Date().getTime() < now + wait) {}
      this.$store.dispatch('selectedRole', 'PreChecker')
      while (new Date().getTime() < now + wait) {}
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser', userScope: 'userScope', loadingUserScope: 'loadingUserScope' })
    // ...mapState({ loadingUserScope: 'auth.loadingUserScope' })
  }
  // watch: {
  //   userScope: function () {
  //     this.loggingIn = this.userScope == null
  //     this.hasScope = true
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.el-card {
  background-color: #b3c0d1;
}
.el-row {
  display: flex;
  justify-content: center;
  margin-top: 60px;
  margin-bottom: 60px;
}
.bg-purple {
  background: #d3dce6;
}
body {
  background: rgb(255, 255, 255);
}

.login-wrapper {
  background: #fff;
  width: 70%;
  margin: 12% auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/E2eTest.vue